import { fetchDictionaries } from '../../../services/DictionaryService';
import { BUNDLED_TRANSLATIONS, DEFAULT_LANGUAGE_CODE } from '../../../utils/helpers/defaultLanguage';

const getLanguageCode = (activeLanguage) => (activeLanguage?.code === 'es' ? 'es' : DEFAULT_LANGUAGE_CODE);

/**
 * Legacy entry point for screens still on react-localize-redux: feeds their provider from
 * DictionaryService. Delete it with the last screen that imports it.
 * @param {{code: string}} [activeLanguage] - Language of the legacy provider.
 * @param {Function} [addTranslationForLanguage] - The legacy provider's setter.
 * @param {boolean} [isAlwaysGetLanguage] - Fetches the dictionaries again instead of reusing them.
 * @returns {Promise<void>} Resolves once the backend dictionary is applied.
 * @author armandoricosandoval -ai-
 */
const addTranslationsForActiveLanguage = async (activeLanguage, addTranslationForLanguage, isAlwaysGetLanguage = false) => {
  const code = getLanguageCode(activeLanguage);
  const applyTranslations = typeof addTranslationForLanguage === 'function' ? addTranslationForLanguage : () => {};

  applyTranslations({ ...BUNDLED_TRANSLATIONS[code] }, code);
  const dictionaries = await fetchDictionaries({ force: isAlwaysGetLanguage });
  applyTranslations({ ...BUNDLED_TRANSLATIONS[code], ...dictionaries[code] }, code);
};

export default addTranslationsForActiveLanguage;
